import md5 from "md5";
import { getMonthsArray } from "../";

export const tariffMonthlyRowsCombined = (data, gettext) => {
  const rows = [];

  const taxes = data?.tariffDetails?.taxes;
  const monthsArray = getMonthsArray(gettext);
  const monthIndex = data?.tariffDetails?.month || 0;
  const selectedMonth = monthsArray[monthIndex].value;

  if (Array.isArray(taxes) && taxes.length > 0) {
    taxes.map((objTaxData) => {
      const orderNo = objTaxData?.meteringPointId;

      if (!rows["all"]) {
        rows["all"] = [];
      }

      if (!rows[selectedMonth]) {
        rows[selectedMonth] = [];
      }

      objTaxData.rabatNettariffHourly.map((rabatNettariffHourly) => {
        const rowIndex = [];
        const id = md5(rabatNettariffHourly.ts);
        rowIndex["all"] = rows["all"].findIndex((obj) => obj.id === id);
        rowIndex[selectedMonth] = rows[selectedMonth].findIndex(
          (obj) => obj.id === id,
        );
        if (rowIndex["all"] > -1) {
          rows["all"][rowIndex["all"]][`rabatNettariff_${orderNo}`] =
            rabatNettariffHourly.tariff;
        } else {
          const row = {
            id: id,
            ts: rabatNettariffHourly.ts,
          };
          row[`rabatNettariff_${orderNo}`] = rabatNettariffHourly.tariff;
          rows["all"].push(row);
        }

        if (rowIndex[selectedMonth] > -1) {
          rows[selectedMonth][rowIndex[selectedMonth]][
            `rabatNettariff_${orderNo}`
          ] = rabatNettariffHourly.tariff;
        } else {
          const row = {
            id: id,
            ts: rabatNettariffHourly.ts,
          };
          row[`rabatNettariff_${orderNo}`] = rabatNettariffHourly.tariff;
          rows[selectedMonth].push(row);
        }
        return null;
      });

      objTaxData.nettariffHourly.map((nettariffHourly) => {
        const rowIndex = [];
        const id = md5(nettariffHourly.ts);
        rowIndex["all"] = rows["all"].findIndex((obj) => obj.id === id);
        rowIndex[selectedMonth] = rows[selectedMonth].findIndex(
          (obj) => obj.id === id,
        );
        if (rowIndex["all"] > -1) {
          rows["all"][rowIndex["all"]][`nettarif_${orderNo}`] =
            nettariffHourly.tariff;
        } else {
          const row = {
            id: id,
            ts: nettariffHourly.ts,
          };
          row[`nettarif_${orderNo}`] = nettariffHourly.tariff;
          rows["all"].push(row);
        }

        if (rowIndex[selectedMonth] > -1) {
          rows[selectedMonth][rowIndex[selectedMonth]][`nettarif_${orderNo}`] =
            nettariffHourly.tariff;
        } else {
          const row = {
            id: id,
            ts: nettariffHourly.ts,
          };
          row[`nettarif_${orderNo}`] = nettariffHourly.tariff;
          rows[selectedMonth].push(row);
        }
        return null;
      });

      return null;
    });
  }
  return rows;
};
